import Vue from "vue";

// for resetState
const getDefaultState = () => {
    return {};
};

// initial state
const state = {};

// mutations
const mutations = {
    SOCKET_DATABASE_UPDATE(state, payload) {
        for (const db in payload) {
            console.log("database update: " + db, (payload[db].data || []).length, "records");
 
            const o = {};
            o.data = {};
            o.format = payload[db].format;
            o.module = payload[db].module;
            for (const e of payload[db].data) o.data[e._id] = e;

            Vue.set(state, db, o);
        }
    },
    SOCKET_DATABASE_DOCUMENT(state, { db, document }) {
        if (!state[db]) return console.log("database don1t exists:", db);
        console.log("database " + db + " document: " + document.name || document._id);
        Vue.set(state[db].data, document._id, document);
    },
};

const getters = {
    // get the format schema of a database
    // $store.getters['database/getDatabaseFormat'](db)
    getDatabaseFormat: (state) => (db) => {
        if (db === undefined) return null;
        if (state[db] === undefined) return null;
        return { ...state[db].format };
    },
    // Access with $store.getters['database/getDatabaseList']
    // returns an array of database names
    getDatabaseList: (state, getters) => {
        return Object.keys(state);
    },
    // /@vue-modules/database/vue/database-components/database-card.vue?line=84
    // returns an array or null
    getDatabaseArrayData: (state) => (db) => {
        if (db === undefined) return null;
        if (state[db] === undefined) return null;
        return Object.values(state[db].data);
    },
    // /@vue-modules/databases/run/define.mjs
    // returns an array of text/value objects for vuetify
    getDatabaseDocumentsNameIdArray: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        return Object.values(state[db].data).map((e) => {
            return { text: e.name, value: e._id };
        });
    },
    getDatabaseDocumentsFirstElement: (state) => (db) => {
        if (db === undefined) return {};
        if (state[db] === undefined) return {};
        if (state[db].data.length < 1) return {};
        const e = Object.values(state[db].data)[0];
        return { text: e.name, value: e._id };
    },
    // getDatabaseDocumentsNameIdArray with a filter applied, for selecting a set of documents by a value
    getDatabaseDocumentsNameIdArrayFilterByFieldValue: (state) => (db, field, value) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        return Object.values(state[db].data)
            .filter((e) => e[field] === value)
            .map((e) => {
                return { text: e.name, value: e._id };
            });
    },
    // used in query_filters .. TODO make it more generic
    getDatabaseDocumentsNameIdArrayDualFilterByFieldValue: (state) => (db, field1, value1, field2, value2) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        return Object.values(state[db].data)
            .filter((e) => e[field1] === value1)
            .filter((e) => e[field2] === value2)
            .map((e) => {
                return { text: e.name, value: e._id };
            });
    },
    //
    getDatabaseDatafields: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        // format must exists now
        return Object.keys(state[db].format);
    },
    getDatabaseDatafieldFormat: (state) => (db, field) => {
        if (db === undefined) return {};
        if (state[db] === undefined) return {};
        // format must exists now
        return state[db].format[field];
    },
    // @vue-modules/databases/datafields/4110.DATABASES_FIELD_COMPONENTS.database-document-indirect-reference.mjs?line=14
    getDatabaseRefDatafields: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        // format must exists now
        return Object.keys(state[db].format).filter((e) => state[db].format[e].ref !== undefined);
    },
    getDatabaseRefDatabases: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        // format must exists now
        return Object.keys(state[db].format)
            .filter((e) => state[db].format[e].ref !== undefined)
            .map((e) => state[db].format[e].ref);
    },
    // get fields
    getDatabaseResolvingDatafields: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        const results = [];

        const date_keys = Object.keys(ß.logic.objectifyDate());

        // recursive function
        function getFields(_db, path, depth) {
            // stop conditions
            if (depth > 10) return console.log("[database] getDatabaseResolvingDatafields depth limit reached on " + db);
            if (depth > 0) if (db === _db) return;
            // mongoose fields
            results.push(path + "createdAt");
            //date_keys.forEach(key => results.push(path + 'createdAt.' + key));
            //date_keys.forEach(key => results.push(path + 'updatedAt.' + key));
            results.push(path + "updatedAt");

            // single fields
            Object.keys(state[_db].format).forEach((field) => {
                const def = state[_db].format[field];
                if (!def) return; // console.log("no def",_db,field);
                if (def.multiple) return;

                const ref = def.ref;
                if (!ref) return results.push(path + field);
                getFields(ref, path + field + ".", depth + 1);
            });
        }

        getFields(db, "", 0);

        return results;
    },
    // get database references
    getDatabaseResolvingDatafieldReferences: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        const results = [];

        // recursive function
        function getFields(_db, path, depth) {
            // stop conditions
            if (depth > 10) return console.log("[database] getDatabaseResolvingDatafields depth limit reached on " + db);
            if (depth > 0) if (db === _db) return;

            // single fields
            Object.keys(state[_db].format).forEach((field) => {
                const def = state[_db].format[field];
                if (!def) return;
                if (def.multiple) return;

                const ref = def.ref;
                if (!ref) return;
                results.push(path + field);
                getFields(ref, path + field + ".", depth + 1);
            });
        }

        getFields(db, "", 0);

        return results;
    },

    hasDatabaseDatafield: (state) => (db, field) => {
        if (!field) return "-";
        if (state[db]) if (state[db].format) if (state[db].format[field]) return true;
        return false;
    },
    // @vue-modules/databases/datafields/4110.DATABASES_FIELD_COMPONENTS.database-document-indirect-reference.mjs?line=22
    getDatafieldRef: (state) => (field) => {
        if (!field) return "-";
        let ref = null;
        for (const dbx in state)
            if (state[dbx].format) if (state[dbx].format[field] !== undefined) if (state[dbx].format[field].ref !== undefined) ref = state[dbx].format[field].ref;

        return ref;
    },

    // database document indirect value
    // @vue-modules/databases/datafields/4110.DATABASES_FIELD_COMPONENTS.database-document-indirect-reference.mjs?line=28
    getDatabaseIndirectRefDatafields: (state) => (field) => {
        if (!field) return [];

        let ref = null;
        for (const dbx in state)
            if (state[dbx].format) if (state[dbx].format[field] !== undefined) if (state[dbx].format[field].ref !== undefined) ref = state[dbx].format[field].ref;

        if (!ref) {
            console.log(ref, "No DB ref");
            return [];
        }
        if (state[ref] === undefined) {
            console.log(ref, "No state");
            return [];
        }
        // format must exists now
        const ret = Object.keys(state[ref].format)
            .filter((e) => state[ref].format[e].ref !== undefined)
            .filter((e) => state[ref].format[e].multiple === true);
        console.log(ref, ret);
        return ret;
    },
    // @vue-modules/databases/run/define.mjs
    getDatabaseDocumentDatafieldValuesAsNameIdArray: (state) => (db, doc, field) => {
        if (!db) return [];
        if (!doc) return [];
        if (!field) return [];

        let ref = null;
        for (const dbx in state)
            if (state[dbx].format) if (state[dbx].format[field] !== undefined) if (state[dbx].format[field].ref !== undefined) ref = state[dbx].format[field].ref;

        if (!ref) return [];
        if (state[db] === undefined) return [];
        if (state[ref] === undefined) return [];

        if (!state[db].data[doc]) return [];
        if (!state[db].data[doc][field]) return [];

        return state[db].data[doc][field]
            .filter((e) => state[ref].data[e] !== undefined)
            .map((e) => {
                return { text: state[ref].data[e].name, value: e };
            });
    },
    // a property of databases
    getDatabaseModule: (state) => (db) => {
        if (db === undefined) return null;
        if (state[db] === undefined) return null;
        return state[db].module || "unknown";
    },
    getDatabaseModules: (state) => {
        return [...new Set(Object.keys(state).map((db) => state[db].module))];
    },
    getDatabaseListByModule: (state, getters) => (module) => {
        return Object.keys(state).filter((e) => state[e].module === module);
    },
    /*
    // unused
    getDatafieldList: (state, getters) => {
        const list = [];
        for (const db in state) for (const field in state[db].format) list.push(field);
        return list;
    },
    // unused
    getDatabaseDatafields: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        // format must exists now
        return Object.keys(state[db].format);
    },
    
    getDatabaseDatafieldsWithSingleValue: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        // format must exists now
        return Object.keys(state[db].format).filter(e => state[db].format[e] && state[db].format[e].multiple !== true);
    },    
    
    getDatabaseDatafieldsWithMultiple: (state) => (db) => {
        if (db === undefined) return [];
        if (state[db] === undefined) return [];
        // format must exists now
        console.log(Object.keys(state[db].format));
        return Object.keys(state[db].format).filter(e => state[db].format[e] && state[db].format[e].multiple === true);
    },
    
    getDatabaseDocumentById: (state) => (db, id) => {
        if (db === undefined) return null;
        if (id === undefined) return null;
        if (state[db] === undefined) return null;
        return { ...state[db].data.filter((e) => e._id === id)[0] };
    },*/

    // these are more database-document related operations
    getDocumentById: (state) => (db, id) => {
        if (db === undefined) return null;
        if (state[db] === undefined) return null;
        if (id === undefined) return null;
        return state[db].data[id];
    },
    // assume name is unique in each database
    getDocumentByName: (state) => (db, name) => {
        if (db === undefined) return null;
        if (state[db] === undefined) return null;
        if (name === undefined) return null;
        // format must exists now
        const a = Object.values(state[db].data).filter((e) => e.name === name);
        if (a.length > 0) return a[0];
        return null;
    },
    hasDatabase: (state) => (db) => {
        if (db === undefined) return false;
        if (state[db] !== undefined) return true;
        return false;
    },
    getReferencedDocumentsProperty: (state) => (db, arr, prop) => {
        if (db === undefined) return null;
        if (state[db] === undefined) return null;
        if (arr === undefined) return null;
        if (prop === undefined) return null;

        return arr.map((e) => state[db].data[e][prop]);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};
